export enum FormDataTypes {
  FILE = 'file',
  DATA = 'data',
  DOCUMENT_NAME = 'documentName',
  DOCUMENT_TYPE = 'documentType'
}
